import { createStackNavigator } from '@react-navigation/stack';
import type { RootStackParamList } from './types';

export const Stack = createStackNavigator<RootStackParamList>();
